export function onSelect(eventId: string, onSelectEvent: any): void {
      if (onSelectEvent) {
  onSelectEvent(eventId);
   }
}